import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tagNames', 'tagList', 'tagForm', 'tagInput']
  static classes = ['enabled', 'newTag', 'addTag', 'clickable']

  initialize () {
    this.tags = JSON.parse(this.tagNamesTarget.value)
    this.renderTags()
  }

  toggle (event) {
    const tag = event.srcElement.innerText
    const index = this.tags.indexOf(tag)
    if (index !== -1) {
      this.tags.splice(index, 1)
    } else {
      this.tags.push(tag)
    }
    this.renderTags()
  }

  renderTags () {
    const tagNames = this.tagNamesTarget
    tagNames.value = JSON.stringify(this.tags)

    const tagList = this.tagListTarget

    for (const element of tagList.children) {
      if (this.tags.includes(element.innerText)) {
        element.classList.add(this.enabledClass)
      } else {
        if (element.classList.contains(this.newTagClass)) {
          element.parentNode.removeChild(element)
        } else {
          element.classList.remove(this.enabledClass)
        }
      }
    }

    this.reOrderTags(tagList)
  }

  reOrderTags (tagList) {
    const enabledTags = tagList.querySelectorAll(`div.${this.enabledClass}`)
    const newTags = tagList.querySelectorAll(`div.${this.newTagClass}`)
    const disabledTags = tagList.querySelectorAll(`div.tag:not(.${this.newTagClass}):not(.${this.enabledClass}):not(.${this.addTagClass})`)

    const sortedEnabledTags = this.sort(enabledTags)
    const sortedNewTags = this.sort(newTags)
    const sortedDisabledTags = this.sort(disabledTags)
    const sortedTags = sortedEnabledTags.concat(sortedNewTags, sortedDisabledTags)

    sortedTags.forEach(tag => {
      tagList.lastElementChild.insertAdjacentElement('beforebegin', tag)
    })
  }

  sort (tags) {
    return [].slice.call(tags).sort(function (a, b) {
      return a.innerText > b.innerText ? 1 : -1
    })
  }

  addNew (event) {
    event.preventDefault()
    const tagList = this.tagListTarget
    const tagInput = this.tagInputTarget
    const tagValue = tagInput.value.trim()

    if (tagValue === undefined || tagValue === null || tagValue === '') {
      tagInput.value = ''
      return
    } else if (!this.tags.includes(tagValue)) {
      for (const element of tagList.children) {
        if (element.innerText === tagValue) {
          tagInput.value = ''
          return
        }
      }

      this.tags.push(tagValue)
      tagList.lastElementChild.insertAdjacentHTML('beforebegin', `
      <div class="tag ${this.newTagClass} ${this.enabledClass} ${this.clickableClass}" data-action="click->tags#toggle">
      ${tagValue}
      </div>
      `)
    }

    this.renderTags()
    tagInput.value = ''
  }

  toggleTagForm (event) {
    event.preventDefault()
    const element = this.tagFormTarget
    element.hidden = !element.hidden
  }
}
